import React, { useContext, useEffect } from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import { Card, Col, Row } from "react-bootstrap";
import Background from "../../common/Background";
import Flex from "../../common/Flex";
import Section from "../../common/Section";
import "../../../style.css";
import halfCircle from "../../../assets/img/illustrations/half-circle.png";
import Logo from "../../navbar/Logo";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faFacebook,
  faLinkedin,
  faTwitter,
} from "@fortawesome/free-brands-svg-icons";

import AppContext from "../../../context/Context";
import { useLocation } from "react-router";
import sai_logo from "../../../../src/assets/img/logos/sai-logo.png"

const SaiAuthCardLayout = ({
  leftSideContent,
  children,
  footer = true,
  height,
}) => {
  const { loginUserDetails, isDark } = useContext(AppContext);
  const useQuery = () => {
    const { search } = useLocation();
    return React.useMemo(() => new URLSearchParams(search), [search]);
  };
  const query = useQuery();
  const isApiPlusExist = sessionStorage.getItem("api_plus_plus")
    ? JSON.parse(sessionStorage.getItem("api_plus_plus"))
    : false;

  useEffect(() => {
    if ((window.location.href.includes("authentication/sai-register") && query.get("request") == "apiplusplus" &&
      query.get("callback_key") &&
      query.get("redirect_url")) || isApiPlusExist) {

    } else {
      window.location.href = `${process.env.PUBLIC_URL}/authentication/register`;
    }
  }, [window.location.href])


  return (
    <Section fluid className={`py-0 sai_container`}>
      <Row className="g-0 min-vh-100 flex-center">
        <Col sm={10} lg={8} xxl={5} className="py-3 position-relative">
          {/* <Row>
            <Col>
              <img
                className=""
                style={{
                  width: "100%",
                  borderRadius: "0.5em",
                  margin: "0.6em 0",
                  cursor: "pointer"
                }}
                src={"https://sikka.ai/V4/images/banners/ai-banner-jan.png"}
                alt=""
                width="250"
                onClick={() => {
                  window.open("https://summit.sikkasoft.com/", "_blank");
                }}
              />
            </Col>
          </Row> */}
          <Card
            className={`overflow-hidden z-index-1 sai_card_container`}
            style={{ height: height }}
          >
            <Card.Body className="p-0">
              <Row className="h-100 g-0 ">
                <Col
                  md={6}
                  className={`text-center`}
                  style={{
                    display: "grid",
                    justifyItems: "center",
                  }}
                >
                  <div className="position-relative p-4 pt-md-5 pb-md-7">
                    <div className="z-index-1 position-relative light">
                      <Logo
                        src={`https://sikka.ai/V3/img/sikka-ai-logo-white.png`}
                        className={"sai-logo-brand-design"}
                        externalURL={"https://www.sikka.ai/oneapi"}
                      />

                      <>
                        <img
                          src={sai_logo}
                          width="140"
                          height="auto"
                          className="position-relative pt-md-8 pb-md-5"
                          alt="SAI logo"
                        />
                      </>
                    </div>
                  </div>
                  <div
                    className={`mt-3 mb-4 mb-md-3`}
                    style={{
                      // position: "absolute",
                      bottom: "0%",
                      textAlign: "center",
                    }}
                  >
                    {leftSideContent}

                    <>
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          fontSize: "0.8em",
                        }}
                      >
                        <a
                          href="tel:1-800-947-4552"
                          className="sai_secondary_text"
                          rel="noreferrer"
                        >
                          1-800-94-SIKKA
                        </a>
                        {"|"}
                        <a
                          href="mailto:info@sikka.ai"
                          className="sai_secondary_text"
                          rel="noreferrer"
                        >
                          <p className="text-left">info@sikka.ai</p>
                        </a>
                      </div>

                      <Row className="d-flex justify-content-center mb-1">
                        <Col>
                          <Link
                            className="text-decoration-underline text-white"
                            to={{
                              pathname:
                                "https://www.facebook.com/SikkaSoftware",
                            }}
                            target="_blank"
                          >
                            <FontAwesomeIcon
                              className="mx-2"
                              icon={faFacebook}
                            />
                          </Link>
                          <Link
                            className="text-decoration-underline text-white"
                            to={{
                              pathname: "https://twitter.com/SikkaSoftware",
                            }}
                            target="_blank"
                          >
                            <FontAwesomeIcon
                              className="mx-2"
                              icon={faTwitter}
                            />
                          </Link>
                          <Link
                            className="text-decoration-underline text-white"
                            to={{
                              pathname:
                                "https://www.linkedin.com/company/sikka-ai",
                            }}
                            target="_blank"
                          >
                            <FontAwesomeIcon
                              className="mx-2"
                              icon={faLinkedin}
                            />
                          </Link>
                        </Col>
                      </Row>
                      <Row className={`text-center ${"brand-policy"}`}>
                        <Col>
                          <Link
                            className="text-decoration-underline text-white fs--1"
                            to={{
                              pathname:
                                "https://www.sikkasoft.com/terms-of-service",
                            }}
                            target="_blank"
                          >
                            Terms of Service
                          </Link>
                          |
                          <Link
                            className="text-decoration-underline text-white fs--1"
                            to={{
                              pathname:
                                "https://www.sikkasoft.com/privacy-policy",
                            }}
                            target="_blank"
                          >
                            Privacy Policy
                          </Link>
                          |
                          <Link
                            className="text-decoration-underline text-white fs--1"
                            to={{
                              pathname:
                                "https://www.sikkasoft.com/terms-of-service#hipaa",
                            }}
                            target="_blank"
                          >
                            HIPAA Policy
                          </Link>
                        </Col>
                      </Row>

                      <p className="ml-1 mt-2 fs--1 fw-semi-bold text-white opacity-100 text-center">
                        &copy; {new Date().getFullYear()} Copyright Sikka
                        Software Corporation. All Rights Reserved.
                        <br />
                        <span className="fs--2">
                          Leading AI infrastructure as a Service (AIaaS) for
                          Retail Healthcare
                        </span>
                      </p>
                    </>
                  </div>
                </Col>
                <Col
                  md={6}
                  as={Flex}
                  alignItems="center"
                  justifyContent="center"
                  className={"sai-card-form-brand-design"}
                >
                  <div className="p-3 p-md-3 flex-grow-1">{children}</div>
                </Col>
              </Row>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Section>
  );
};
SaiAuthCardLayout.propTypes = {
  leftSideContent: PropTypes.node,
  children: PropTypes.node.isRequired,
  footer: PropTypes.bool,
};

export default SaiAuthCardLayout;
